"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumCrossellData = void 0;
const actions_1 = require("./actions");
const tracking_utils_1 = require("./tracking.utils");
exports.TealiumCrossellData = {
    [actions_1.CROSSELL_MODULE_VIEW]: ({ item, index }) => ({
        action: actions_1.TealiumAction.VIEW,
        format: actions_1.TealiumFormat.BANNER,
        component: actions_1.TealiumComponent.CROSSELL_MODULE,
        element: 'full',
        eventCategory: (0, tracking_utils_1.getEventCategory)(window.location.pathname),
        eventAction: actions_1.TealiumEventAction.VIEW_BANNER,
        eventLabel: 'full',
        tealium_event: 'product_impression',
        product_name: [`${item.title}`],
        product_position: [`${index + 1}`],
        atActivity: item.feedback.activityId,
        atOffer: item.feedback.offerId,
        atExperience: item.feedback.experienceId,
        atTrafficAllocation: item.feedback.trafficAllocationId,
    }),
    [actions_1.CROSSELL_MODULE_OPEN]: ({ item, index, title }) => ({
        action: actions_1.TealiumAction.OPEN,
        format: actions_1.TealiumFormat.BANNER,
        component: actions_1.TealiumComponent.CROSSELL_MODULE,
        element: `crossellProduct0${index + 1}`,
        eventCategory: (0, tracking_utils_1.getEventCategory)(window.location.pathname),
        eventAction: `crossellProduct0${index + 1}`,
        eventLabel: 'open',
        tealium_event: 'product_click',
        product_name: [`${title}`],
        product_position: [`${index + 1}`],
        atActivity: item.feedback.activityId,
        atOffer: item.feedback.offerId,
        atExperience: item.feedback.experienceId,
        atTrafficAllocation: item.feedback.trafficAllocationId,
    }),
};
//# sourceMappingURL=tealium.js.map